import formatSeconds from './format-seconds'

export default seconds => formatSeconds(seconds, 2)
